export const environment = {
  production: false,
  SERVER_URL: `https://admin-dev.co-nurse.jp/api/v1`,
  //SERVER_URL: `http://localhost:8080/api/v1`,
  SECRET_KEY: `Co-Nurse-APP-SECRET-2024!@#`,
}